import TraitContent from "./TraitContent";

export default TraitContent;
export { TraitContent };
